<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="prodenccif"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="Confirmacionprodenccif" title="Confirmar Acción"
				 appendTo="body"></p-confirmDialog>

<div class="p-grid" style="width: 99%">
	<div class="p-col-12">
		
<app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonBorrar]="btnBorrar"
						 [botonRegresar]="btnRegresar" [barraBotonesCRUD]="false"
						 [barraBotonesDesplaz]="false" [barraBotones3]="true" [barraBotonesAsiCon]="false"
                         [barraBotones5]="false" [barraBotones3Alt]="false" 
                         [botonAlmacenardoc]="true" [botonBuscar]="false" [botonBinocular]="true"
                         [botonverAsiento]="false" [botonAsiento]="false"
						 (signal)="manejarSenales($event)"></app-invmaebarra>
                       
                        
                       
                         <!-- <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar"
                         [botonBorrar]="btnBorrar" [botonRegresar]="btnRegresar"  
                         [barraBotones3]="true" [barraBotonesDesplaz]="false"
                         [barraBotonesAsiCon]="false"
                         [botonPrimero]="!botonPrimero" [botonAnterior]="!botonAnterior" [botonSiguiente]="!botonSiguiente"
                         [botonUltimo]="!botonUltimo" [barraBotones5]="true"
                         [botonAlmacenardoc]="true" [botonBuscar]="false"  [botonverAsiento]="false" [botonAsiento]="false">
                         
                         </app-invmaebarra> -->
	</div>
</div>
<div class="p-col-12">
    <div class="divgrups2" style="margin-top: -10px; margin-bottom: -10px; width: 99%">
        <div class="p-col-12">
            <div class="p-grid" style="margin-top: -10px; margin-bottom: -10px;">
                <div class="p-col-10"></div>

                <div class="p-col-2">
                    <input type="text" pInputText style="background-color: deepskyblue;"
                        [(ngModel)]="prodcosindfaseService.enccif[indicador].ASI_NRO" [disabled]="true">
                </div>
            </div>
        </div>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-1">
                            <span>Num Doc.:</span>
                        </div>
                        <div class="p-col-1">
                            <label for="ENCCIF_COMPROBANTE"></label>
                            <input class="frm" id="ENCCIF_COMPROBANTE" type="text" pInputText disabled
                                [(ngModel)]="prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE"
                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                autocomplete="off">
                        </div>
                        <div class="p-col-12" style="margin-top: -5px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Fecha Emisión:</span>
                                </div>
                                <div class="p-col-1">
                                    <p-calendar id="ENCCIF_FECHAEMISION"
                                    [inputStyle]="{width: '100%', height: '20px'}"
                                    [(ngModel)]="prodcosindfaseService.enccif[indicador].ENCCIF_FECHAEMISION"
                                    [readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
                                    (keydown)="botonesmodificar()">
                                </p-calendar>
                                </div>
                                <div class="p-col-1">
                                    <span > Orden Producción:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="ENCORDPRO_NUMERO"></label>
                                    <input class="frm" id="ENCORDPRO_NUMERO" type="text" pInputText 
                                    [disabled]="prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== ''
                                     && prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== undefined"
                                        [(ngModel)]="prodcosindfaseService.enccif[indicador].ENCORDPRO_NUMERO"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button" [disabled]="prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== ''
                                    && prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== undefined"

                                    style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                    (click)="busqueOrdenProd(prodcosindfaseService.enccif[indicador].ENCORDPRO_NUMERO)"></button>
                                </div>
                                <div class="p-col-1">
                                    <span > Estado:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="lblestado"></label>
                                    <input class="frm" id="lblestado" type="text" pInputText disabled
                                        [(ngModel)]="lblestado"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                            </div>
                        </div>
                        
                       
                        <!--LINEA 2-->
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Centro Trabajo:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="CENTRA_CODIGO"></label>
                                    <input class="frm" id="CENTRA_CODIGO" type="text" pInputText 
                                    [disabled]="prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== ''
                                     && prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== undefined"

                                        [(ngModel)]="prodcosindfaseService.enccif[indicador].CENTRA_CODIGO"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button" [disabled]="prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== ''
                                     && prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE !== undefined"
                                    style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                    (click)="busqueCenTrab(prodcosindfaseService.enccif[indicador].CENTRA_CODIGO)"></button>
                                </div>
                                <div class="p-col-2">
                                    <label for="CENTRA_DESCRIPCION"></label>
                                    <input class="frm" id="CENTRA_DESCRIPCION" type="text" pInputText disabled
                                        style="color: blue;"
                                        [(ngModel)]="prodcosindfaseService.enccif[indicador].CENTRA_DESCRIPCION"
                                        autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <!--LINEA 3-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Comentario:</span>
                                </div>
                                <div class="p-col-5">
                                    <label for="ENCCIF_COMENTARIO"></label>
                                    <input class="frm" id="ENCCIF_COMENTARIO" type="text" pInputText
                                    [maxLength]="98"
                                                [(ngModel)]="prodcosindfaseService.enccif[indicador].ENCCIF_COMENTARIO"
                                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                                autocomplete="off">
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-aggridsaci 
            [width]=""
            [height]="-3800" 
            [enableSorting]="false" 
            [enableFilter]="true"
            [rowData]="prodcosindfaseService.detcif" 
            [frameworkComponents]="frameworkComponents"
            [animateRows]="true" 
            [rowSelection]="rowSelection" 
            [columnDefs]="columnDefsProddetcif"
            [defaultColDef]="defaultProdDetcif" 
            [rowStyle]="rowStyle" 
            [singleClickEdit]="false" 
            [botones]="true"
            [mostrarGuardar]="false" 
            [botonesAdicionales]="false" 
            [comboOpciones]=""
           
            (selected)="seleccionItem($event)" 
            [tipodetalle]=""
            [botonBorrar]="false"
            (cambios)="cambio($event)"
            
            >
            </app-aggridsaci>
            <div class="divgrupstabla">
                <div class="p-grid">

                    <div class="p-col-12" style="margin-top: -10px;">
                        <div class="p-grid">
                            <div class="p-col-6"></div>
                            <div class="p-col-2">
                                <!-- <span class="obligatorio">Total deuda</span> -->
                            </div>				
                            <div class="p-col-2">
                               
                            </div>
                            <div class="p-col-2">
                                <span class="obligatorio">Total Costos</span>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12" style="margin-top: -15px; margin-bottom: -15px">
                        <div class="p-grid">
                            <div class="p-col-6"></div>
                            <div class="p-col-2">
                                <!-- <input type="text" class="totales" pInputText
                                    [(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].TOTALDEUDA"
                                    [disabled]="true" autocomplete="off"> -->
                            </div>
                            <div class="p-col-2">
                                
                            </div>
                            <div class="p-col-2">
                                <input type="text" class="totales" pInputText
                                    [(ngModel)]="prodcosindfaseService.enccif[indicador].ENCCIF_TOTAL"
                                    [disabled]="true" autocomplete="off">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>

<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast"
		  [transitionOptions]="'0ms'"
		  [modal]="false"
		  [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla"
					 [busquedaParams]="busquedacampos" [consulta]="consulta" [where]="where"
					 (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<p-dialog header="Reportes" [(visible)]="displayDialogReportes" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '40vw', height: '400px'}">
	<app-sacimaecfngimpr [auxiliar]="auxreporte" [strNombreForma]="strNombreForma"
        [strNumDoc]="prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE" [strCampo]="'ENCCIF_COMPROBANTE'"
        [botonExcel]="true"
		(cerrar)="cerrarReportes()"></app-sacimaecfngimpr>
</p-dialog>


<p-dialog header="Documentos" [(visible)]="displayDialogDocumentos" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '50vw', height: 'auto'}">
	<app-uploadfiles *ngIf="displayDialogDocumentos" [txtOrigen]="'PRODENCCIF'"
        [txtNumComprobante]="prodcosindfaseService.enccif[indicador].ENCCIF_COMPROBANTE"
        [boolpercont]="false"
		(signalSalir)="recibirSenalesDocumentos($event)">

	</app-uploadfiles>
</p-dialog>

<p-dialog header="Asiento Contable" [(visible)]="displayAsiContable" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width:'90vw', height:'120vh'}" [draggable]="false">
    <app-conencasil *ngIf="displayAsiContable" [NumAsientoBan]="asiento" [abiertoDesde]="'prodenccif'"
        (signalSalir)="recibirSenalesConEncasil($event)"></app-conencasil>
</p-dialog>